import { useState } from 'react';

const ChatHeader = ({ chat }) => {
  const [showInfo, setShowInfo] = useState(false);
  if (!chat) return null;

  return (
    <div className='chat-header'>
      <img   src={chat?.client?.avatar || `https://picsum.photos/seed/${chat.client.phone.slice(-1)}/100/100`} className='avatar' alt='Аватар' />
      <div className='chat-title'>{chat.client.name}</div>

      <div className='info-button' onClick={() => setShowInfo(!showInfo)}>
        <svg
          width='24'
          height='25'
          viewBox='0 0 24 25'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M12.0871 16.5V12M12.0871 8.49997H12.0771M22 12.5C22 18.0228 17.5228 22.5 12 22.5C6.47715 22.5 2 18.0228 2 12.5C2 6.97715 6.47715 2.5 12 2.5C17.5228 2.5 22 6.97715 22 12.5Z'
            stroke='#FFFEFD'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </svg>
      </div>

      <div
        className={`info-container ${setShowInfo ? 'open' : ''}`}
        style={{ transform: showInfo ? 'scale(1)' : 'scale(0)' }}
      >
        <div style={{ divAlign: 'center', width: '100%' }}>
          <div>Дані запиту</div>
        </div>
        <div>
          Марка: <div>{chat.requestData.mark ?? 'не вказано'}</div>
        </div>
        <div>
          Модель: <div>{chat.requestData.model ?? 'не вказано'}</div>
        </div>
        <div>
          Рік випуску: <div>{chat.requestData.year ?? 'не вказано'}</div>
        </div>
        <div>
          VIN: <div>{chat.requestData.vin ?? 'не вказано'}</div>
        </div>
        <div>
          Телефон: <div>{chat?.client?.phone ?? 'не вказано'}</div>
        </div>
        <div>
          Послуга:
          <div>{chat?.requestData.details?.join(', ') ?? 'не вказано'}</div>
        </div>
      </div>
    </div>
  );
};

export default ChatHeader;
